/**
 * 학습지 개요 → 캔버스.
 * 운영 Firebase Hosting 은 /api rewrite 가 없어 같은 출처 POST 가 index.html 로
 * 떨어지므로, REACT_APP_API_URL 이 비어 있을 때(CRA 프록시)만 같은 출처를 시도한다.
 */

import { buildWorksheetCanvas } from './canvasSchema';

export function shouldTrySameOriginCanvas(apiUrl = process.env.REACT_APP_API_URL) {
  return !String(apiUrl || '').trim();
}

export async function fetchWorksheetCanvasOutline({
  outline,
  includeAnswerGuide = false,
  worksheetStyle,
  theme,
  paperSize,
  orientation,
  signal,
} = {}) {
  if (!outline || typeof outline !== 'object') {
    return { success: false, message: '학습지 내용을 찾을 수 없어요.' };
  }
  const payload = {
    outline,
    includeAnswerGuide,
    worksheetStyle,
    theme,
    paperSize,
    orientation,
    signal,
  };
  if (shouldTrySameOriginCanvas()) {
    try {
      const response = await fetch('/api/worksheet/outline-to-canvas', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          outline,
          theme,
          paper_size: paperSize || 'A4',
          orientation: orientation || 'portrait',
          include_answer_guide: includeAnswerGuide,
          worksheet_style: worksheetStyle || undefined,
        }),
        signal,
      });
      if (response.ok) {
        const data = await response.json();
        if (data?.success && data.outline) return data;
      }
    } catch (_error) {
      // CRA 프록시가 없으면 아래 절대 URL 경로로 이어간다.
    }
  }
  return buildWorksheetCanvas(payload);
}
